<template>
    <q-card class="bg-grey-1">
        <q-card-main class="relative-position" :class="course.is_blocked ? 'no-pointer-events' : 'cursor-pointer'">
            <div class="line-card bg-primary absolute-top"></div>

            <div class="row q-my-sm">
                <div class="col-3" :class="course.is_blocked ? 'disable-image' : ''" @click="goToCourse()">
                    <img class="training-thumb" :src="course.image_small" v-if="course.image_small">
                    <img class="training-thumb" :src="getPlaceholder" v-if="!course.image_small">
                </div>

                <div class="col-8" @click="goToCourse()">
                    <div class="row">
                        <div class="col-12 q-title text-weight-medium" :class="course.is_blocked ? 'text-faded' : 'text-primary'">
                            {{ course.title }}
                        </div>

                        <div class="col-12 q-mb-md">
                            <q-rating color="amber" slot="subtitle" icon="fas fa-star" v-model="course.stars_rating" :max="5" readonly />
                        </div>

                        <div class="col-12">
                            <div class="row">
                                <div class="col-6">
                                    <p class="caption" v-if="course.areas.length > 0">
                                        {{ $t('areas') }}
                                    </p>
                                    <p v-if="course.areas.length > 0" class="tooltip q-mb-sm">
                                        <span v-for="(area, index) in course.areas" :key="index">
                                            {{ getArea(area) }}<span v-if="(course.areas.length - 1) > index">, </span>
                                        </span>
                                    </p>

                                    <p class="caption" v-if="course.user_groups.length > 0">
                                        {{ $t('groups') }}
                                    </p>
                                    <p v-if="course.user_groups.length > 0" class="tooltip q-mb-sm">
                                        <span v-for="(group, index) in course.user_groups" :key="index">
                                            {{ getGroup(group) }}<span v-if="(course.user_groups.length - 1) > index">, </span>
                                        </span>
                                    </p>
                                </div>

                                <div class="col-6">
                                    <p class="caption" v-if="course.tags.length > 0">
                                        {{ $t('tags') }}
                                    </p>
                                    <p class="tooltip q-mb-sm">
                                        <span v-for="(tag, index) in course.tags" :key="index">
                                            {{ getTag(tag) }}<span v-if="(course.tags.length - 1) > index">, </span>
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-1 text-center" @click="showCertificate()">
                    <vc-donut :sections="!course.is_open ? sections : []" :size="100" unit="%">
                        <h6 v-if="course.user_progress < 100 && course.group_training_user_result_status != 1  && course.group_training_user_result_status != 2 && !course.is_open" :class="course.is_blocked ? 'text-faded' : 'text-primary'">
                            {{ getPercentage(course.user_progress) }}%
                        </h6>

                        <q-icon :name="getResult" :color="getResultColor" size="2rem" v-if="course.user_progress == 100 || course.group_training_user_result_status == 1 || course.group_training_user_result_status == 2 && !course.is_open" />

                        <q-icon name="fal fa-clock" color="primary" size="2rem" v-if="course.is_open">
                            <q-tooltip>
                                {{ $t('this_course_is_being_published_your_progress_will_show_when_its_finished') }}
                            </q-tooltip>
                        </q-icon>

                        <q-tooltip v-if="course.group_training_user_result_status == 2 && !course.is_open">
                            {{ `${$t('you_were_reproved_in')} ${course.group_training_user_result_date}` }}
                        </q-tooltip>
                    </vc-donut>

                    <span class="text-faded" v-if="selected_client_params.group_training_use_basic">
                        <small>{{ $t(getTypeTraining) }}</small>
                    </span>
                </div>
            </div>
        </q-card-main>

        <q-card-separator />

        <q-card-actions v-if="actions.length > 0" >
            <p class="text-center fit">
                <q-btn flat v-for="(action, index) in actions" :key="index" :icon="action.icon" color="primary" :label="getLabel(action.label)" v-if="showAction(action.slug)" :color="getColor(action.slug)" @click="doAction(action.slug)">
                    <q-tooltip>
                        {{ $t(action.tooltip) }}
                    </q-tooltip>
                </q-btn>
            </p>
        </q-card-actions>
    </q-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { colors } from 'quasar'
import { debounce } from 'quasar'

export default {
    props: ['course'],

    data() {
        return {
            selected_client_params: [],
            sections: [],
            is_collapsed: false,
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            all_tags: 'site_lists/tags',
            all_areas: 'site_lists/country_areas',
            group_users: 'site_lists/group_users_labels',
            clients: 'params/clients',
            params_loaded: 'params/params_loaded',
			id_user_client_selected: 'common/id_user_client_selected'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getPlaceholder() {
            if (!this.selected_client_params.group_training_placeholder) return ''
            else return this.selected_client_params.group_training_placeholder
        },

        getResult() {
            if (this.course.group_training_user_result_status == 1) {
                return 'fal fa-trophy'
            }
            else if (this.course.group_training_user_result_status == 2) {
                return 'fal fa-ban'
            }
        },

        getResultColor() {
            if (this.course.group_training_user_result_status == 1) {
                return 'positive'
            }
            else if (this.course.group_training_user_result_status == 2) {
                return 'negative'
            }
        },

        getTypeTraining() {
            if (this.course.group_training_type == 1) return 'basic'
            else if (this.course.group_training_type == 2) return 'advanced'
        },

        actions() {
            let actions = []
            let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if(obj) {
                actions.push({
                    icon: 'fal fa-video',
                    label: 'qty_modules',
                    tooltip: 'modules_quantity',
                    slug: 'modules_quantity'
                })
                actions.push({
                    icon: 'fal fa-pen',
                    label: 'qty_tests',
                    tooltip: 'tests_quantity',
                    slug: 'tests_quantity'
                })
                actions.push({
                    icon: 'fal fa-download',
                    label: 'qty_materials',
                    tooltip: 'support_materials_quantity',
                    slug: 'support_materials_quantity'
                })
                actions.push({
                    icon: 'fal fa-trophy',
                    label: 'score',
                    tooltip: 'score',
                    slug: 'score'
                })
                actions.push({
                    icon: 'fal fa-thumbs-up',
                    label: 'likes',
                    tooltip: 'like',
                    slug: 'likes'
                })
                if(obj.use_comments_group_training) {
                    actions.push({
                        icon: 'fal fa-star',
                        label: 'stars',
                        tooltip: 'add_comment',
                        slug: 'stars'
                    })
                }
                actions.push({
                    icon: 'fal fa-heart',
                    label: 'favorite',
                    tooltip: 'add_favorite',
                    slug: 'favorite'
                })
            }
            return actions
        }

    },

    methods: {
        getArea(id) {
            let obj = this.all_areas.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        getGroup(id) {
            let obj = this.group_users.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        getTag(id) {
            let obj = this.all_tags.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        getDonutColor(percentage) {
            if (percentage > 0 && percentage <= 24) {
                return '#DB2828'
            }
            else if (percentage >= 25 && percentage <= 74) {
                return '#F2C037'
            }
            else if(percentage >= 75) {
                return '#21BA45'
            }
        },

        getPercentage(percentage) {
            if (!percentage) {
                return 0
            }
            else if (percentage < 100) {
                return parseInt(percentage)
            }
        },

        showAction(slug) {
            if (slug == 'score') {
                if (!this.selected_client_params.group_training_use_score) return false
                else return true
            }
            else {
                return true
            }
        },

        getColor(slug) {
            if (slug == 'likes') {
                if (this.course.liked) return 'secondary'
                else return ''
            }
            else if (slug == 'stars') {
                if (this.course.starred) return 'secondary'
                else return ''
            }
            else if (slug == 'favorite') {
                if (this.course.favorited) return 'negative'
                else return ''
            }
            else {
                return ''
            }
        },

        doAction(slug) {
            if (slug == 'likes') {
                this.likeItem()
            }
            else if (slug == 'stars') {
                this.$emit('clickStars', this.course.id)
            }
            else if (slug == 'favorite') {
                this.favoriteItem()
            }
        },

        getLabel(label) {
            switch(label) {
                case 'qty_modules': return this.course.qty_modules
                break
                case 'qty_tests': return this.course.qty_tests
                break
                case 'qty_materials': return this.course.qty_materials
                break
                case 'user_progress_string': return this.course.user_progress_string
                break
                case 'score': return this.course.score
                break
                case 'likes': return this.course.likes
                break
                case 'stars': return `${this.course.stars} / 5`
                break
                case 'workload': return `${this.course.workload}`
                break
            }
        },

        goToCourse() {
            if (!this.course.is_blocked) {
                if (this.$route.name == 'courses') {
                    this.$router.push({ name: 'course', params: { id: this.course.id } })
                }
                else if (this.$route.name == 'trail') {
                    this.$router.push({ name: 'trail_course', params: { id_trail: this.$route.params.id, id: this.course.id } })
                }
            }
        },

        showCertificate() {
            if (this.course.group_training_user_result_status == 1) {
                this.$emit('showCertificate', this.course.id)
            }
        }
    },

	created() {
        if(this.course.workload) {
            this.actions.push({
                icon: 'fal fa-clock',
                label: 'workload',
                tooltip: 'workload',
                slug: 'workload'
            })
        }


        this.sections = []
        if (this.course.group_training_user_result_status != 2) {
            this.sections.push({
                value: this.course.user_progress ? this.course.user_progress > 100 ? 100 : this.course.user_progress : 0,
                color: this.getDonutColor(this.course.user_progress)
            })
        }
        else {
            this.sections.push({
                value: 100,
                color: '#DB2828'
            })
        }

        let client = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
        this.selected_client_params = client ? client : {}
    },

    mounted() {
        this.likeItem = debounce(() => {
            this.$emit('clickLike', this.course.id)
        }, 500)

        this.favoriteItem = debounce(() => {
            this.$emit('clickFavorite', this.course.id)
        }, 500)
    }
}
</script>

<style lang="stylus" scoped>
.line-card
    border-top: 3px solid transparent
    border-top-left-radius inherit
    border-top-right-radius inherit

p
    margin 0 0 5px

.training-thumb
    width 90%
    height auto
    border-radius 10px

.disable-image
    & img
        opacity: 0.5
</style>
